<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :loading="modalLoading" :data="queryInstanceByGroupIdList" style="width: 100.1%;">
            <template slot-scope="{row,index}" slot="actions">
                <span @click="doDelete(index)">
                    <Button type="error" size="small" @click="instanceDelmodal = true">{{ $t('alarms.common.delete') }}</Button>
                </span>
            </template>
        </Table>
        <br>

        <Modal v-model="instanceDelmodal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }} {{name}} {{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long @click="deleteInstance()" :disabled="isDisable">{{ $t('alarms.common.delete') }}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    var tableInstances = {}
    export default {
        name: 'TableInstances',
        data() {
            return {
                name: '',
                modalLoading: true,
                instanceDelmodal: false,
                isDisable: false,
                columns: [
                {
                    title: this.$t('RAM.AWS.computeInstance.instanceID'),
                    key: 'instanceId'
                },
                {
                    title: this.$t('instance_list.instanceName'),
                    key: 'name',
                },
                {
                    title: this.$t('RAM.AWS.computeInstance.region'),
                    key: 'region'
                },
                {
                    title: this.$t('instance_list.privateIP'),
                    key: 'privateIp'
                },
                {
                    title: this.$t('alarms.common.status'),
                    key: 'stateName'
                },
                {
                    title: this.$t('common.operation'),
                    slot: 'actions'
                }],
                queryInstanceByGroupIdList: []
            }
        },
        beforeCreate: function () {
            tableInstances = this
        },
        mounted: function () {
            tableInstances.queryInstancesByGroupId();
        },
        methods: {
            // 点击备份目标的时候显示实例列表
            queryInstancesByGroupId: function () {
                tableInstances.$api.alertRuleExceptionResource.listAlertRuleExceptionResource({
                    "ticketCompanyMonitorItemVariablesId": this.$route.query.id,
                    "monitorModule": this.$route.query.monitorModule
                })
                .then(res => {
                    this.modalLoading = false
                    if(res.data){
                        this.queryInstanceByGroupIdList = res.data;
                    }else{
                        this.queryInstanceByGroupIdList=[];
                    }
                })
            },
            // 显示所有数据
            showAllInstance: function () {
                tableInstances.queryInstancesByGroupId()
            },
            doDelete: function (index) {
                this.lineIndex = index
                this.name = this.queryInstanceByGroupIdList[index].name
            },
            // 删除instance
            deleteInstance: function () {
                this.isDisable = true // 开始可以点击
                var lineIndex = this.lineIndex
                // 删除实例
                tableInstances.$api.alertRuleExceptionResource.softDelete({
                    "ticketCompanyMonitorItemVariablesId":this.$route.query.id,
                    "resourceId":this.queryInstanceByGroupIdList[lineIndex].id
                })
                .then(res => {
                    setTimeout(() => {
                        tableInstances.queryInstancesByGroupId();
                        this.isDisable = false;
                        this.instanceDelmodal = false
                        this.$Message.success('删除成功');
                    }, 1000);                    
                })
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/exception_resource/ec2/TableInstances.vue